import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { BuilderComponent } from "@builder.io/react";
import { builder } from "@builder.io/sdk";
import { getBuilderAPIKey } from "@faire/web--source/builder/BuilderComponents/builderUtils";
import { registerBuilderComponents } from "@faire/web--source/builder/registerBuilderComponents/registerBuilderComponents";
import { registerBuilderDesignTokens } from "@faire/web--source/builder/registerBuilderDesignTokens/registerBuilderDesignTokens";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useMergedRefs } from "@faire/web--source/ui/hooks/useMergedRefs";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import React, { Suspense, use } from "react";
var BigVideoHeaderBannerBase = function(param) {
    var builderPromise = param.builderPromise, loadTimingRef = param.loadTimingRef;
    var builderAPIKey = getBuilderAPIKey();
    if (builderAPIKey) {
        // have to initialize builder here again for preview to work
        builder.init(builderAPIKey);
        // register the components and design tokens
        // have to happen in the client component
        registerBuilderComponents();
        registerBuilderDesignTokens();
    }
    var builderContent = use(builderPromise);
    var trackViewRef = useDoActionWhenVisible(function() {
        return trackLoggedOutRetailersLoggedOutHomeRedesignView("big_video_header_banner", "VARIANT_2");
    });
    var ref = useMergedRefs(loadTimingRef, trackViewRef);
    if (builderContent) {
        return /*#__PURE__*/ _jsx("div", {
            ref: ref,
            children: /*#__PURE__*/ _jsx(BuilderComponent, {
                content: builderContent,
                model: "logged-out-homepage-video-header"
            })
        });
    }
    return null;
};
export var BigVideoHeaderBanner = function(props) {
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(LoadingSkeleton, {
            aspectRatio: {
                mobileAndAbove: "0.9",
                tabletAndAbove: "16/9"
            },
            width: "100%"
        }),
        children: /*#__PURE__*/ _jsx(BigVideoHeaderBannerBase, _object_spread({}, props))
    });
};
